import React from 'react';
import { FileTextOutlined, TagsOutlined, ExclamationCircleOutlined, ShoppingOutlined, DollarOutlined, WarningOutlined, SwapOutlined, BankOutlined, DatabaseOutlined, ApartmentOutlined, SkinOutlined, TransactionOutlined, SafetyCertificateOutlined, UnorderedListOutlined, MedicineBoxOutlined, TeamOutlined, FormOutlined, WalletOutlined, InsuranceOutlined, AlertOutlined, FolderOpenOutlined, ToolOutlined, GiftOutlined, AccountBookOutlined, CalendarOutlined, ClockCircleOutlined, CreditCardOutlined, BarChartOutlined, RollbackOutlined, AuditOutlined, ScissorOutlined, OrderedListOutlined, GlobalOutlined, ExperimentOutlined, SolutionOutlined, BgColorsOutlined, FieldTimeOutlined, CheckCircleOutlined, NotificationOutlined, FileExclamationOutlined, SearchOutlined, CalculatorOutlined, StarOutlined, StarFilled, BugOutlined, ClockCircleFilled, CheckCircleFilled, MoreOutlined, CloseCircleOutlined, RightOutlined, ScheduleOutlined, IdcardOutlined, SafetyOutlined, FileSearchOutlined} from '@ant-design/icons';

export type ERPModule = {
  key: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  path: string;
};

export const modules: ERPModule[] = [
  {
    key: 'sc',
    title: '銷售合約 S/C',
    description: '銷售合約建檔、查詢、管理',
    icon: <FileTextOutlined style={{ fontSize: 22 }} />,
    path: '/sc',
  },
  {
    key: 'product-grade',
    title: '產品等級定義',
    description: '產品等級代號維護 (pw1118f1)',
    icon: <TagsOutlined style={{ fontSize: 22 }} />,
    path: '/product-grade',
  },
  {
    key: 'complaint-desc',
    title: '客訴說明設定',
    description: '客訴說明代碼維護 (pwn102f1)',
    icon: <ExclamationCircleOutlined style={{ fontSize: 22 }} />,
    path: '/complaint-desc',
  },
  {
    key: 'office-supplies',
    title: '事務用品建檔',
    description: '事務用品品項維護 (pwb151f1)',
    icon: <ShoppingOutlined style={{ fontSize: 22 }} />,
    path: '/office-supplies',
  },
  {
    key: 'd103',
    title: '託工類別建檔',
    description: '託工加工類別維護 (pwd103f1)',
    icon: <ToolOutlined style={{ fontSize: 22 }} />,
    path: '/d103',
  },
  {
    key: 'exchange-rate',
    title: '匯率基本檔',
    description: '匯率建檔與管理 (fin_exchangerate)',
    icon: <DollarOutlined style={{ fontSize: 22 }} />,
    path: '/exchange-rate',
  },
  {
    key: 'inv-move-cat',
    title: '庫存異動類別設定',
    description: '庫存異動類別維護 (pwm101f1)',
    icon: <SwapOutlined style={{ fontSize: 22 }} />,
    path: '/inv-move-cat',
  },
  {
    key: 'm106',
    title: '庫存分類維護',
    description: '庫存分類代號維護 (pwm106f1)',
    icon: <DatabaseOutlined style={{ fontSize: 22 }} />,
    path: '/m106',
  },
  {
    key: 'pw1115f1',
    title: '包裝方式建檔',
    description: '包裝方式代號維護 (pw1115f1)',
    icon: <DatabaseOutlined style={{ fontSize: 22 }} />,
    path: '/pw1115f1',
  },
  {
    key: 'pw910cf1',
    title: '新進人員記錄表',
    description: '面試/新進人員記錄維護 (pw910cf1)',
    icon: <SolutionOutlined style={{ fontSize: 22 }} />,
    path: '/pw910cf1',
  },
  {
    key: 'pw0113f1',
    title: '個人密碼更新',
    description: '個人密碼變更 (pw0113f1)',
    icon: <SafetyCertificateOutlined style={{ fontSize: 22 }} />,
    path: '/pw0113f1',
  },
  {
    key: 'company',
    title: '公司資料建檔',
    description: '公司/廠商/銀行資料維護 (pw1104f1)',
    icon: <BankOutlined style={{ fontSize: 22 }} />,
    path: '/company',
  },
  {
    key: 'inv-reason',
    title: '庫存產生原因維護',
    description: '庫存產生原因代號維護 (pwm104f1)',
    icon: <DatabaseOutlined style={{ fontSize: 22 }} />,
    path: '/inv-reason',
  },
  {
    key: 'dept',
    title: '部門建檔',
    description: '部門代號與主管維護 (pw1106f1)',
    icon: <ApartmentOutlined style={{ fontSize: 22 }} />,
    path: '/dept',
  },
  {
    key: 'product',
    title: '產品資料建檔',
    description: '產品主檔與規格維護 (pw1113f1)',
    icon: <SkinOutlined style={{ fontSize: 22 }} />,
    path: '/product',
  },
  {
    key: 'trade-terms',
    title: '交易條件定義',
    description: '交易條件代號維護 (pw1117f1)',
    icon: <TransactionOutlined style={{ fontSize: 22 }} />,
    path: '/trade-terms',
  },
  {
    key: 'quality-req',
    title: '品質要求設定',
    description: '品質要求代號維護 (pw111hf1)',
    icon: <SafetyCertificateOutlined style={{ fontSize: 22 }} />,
    path: '/quality-req',
  },
  {
    key: 'dept-report',
    title: '部門清冊',
    description: '部門清冊列印 (pw1306f1)',
    icon: <UnorderedListOutlined style={{ fontSize: 22 }} />,
    path: '/dept-report',
  },
  {
    key: 'nhi-params',
    title: '健保參數建檔',
    description: '健保投保薪資等級維護 (pw9137f1)',
    icon: <MedicineBoxOutlined style={{ fontSize: 22 }} />,
    path: '/nhi-params',
  },
  {
    key: 'emp-group',
    title: '員工群組設定',
    description: '員工群組代號與成員維護 (pw910tf1)',
    icon: <TeamOutlined style={{ fontSize: 22 }} />,
    path: '/emp-group',
  },
  {
    key: 'remark',
    title: '備註建檔',
    description: '備註代號與內容維護 (pw110cf1)',
    icon: <FormOutlined style={{ fontSize: 22 }} />,
    path: '/remark',
  },
  {
    key: 'casual-payroll',
    title: '非正式人員印領資',
    description: '非正式人員薪資印領維護 (pw913df1)',
    icon: <WalletOutlined style={{ fontSize: 22 }} />,
    path: '/casual-payroll',
  },
  {
    key: 'labor-ins',
    title: '勞保參數建檔',
    description: '勞保費率參數維護 (pw9136f1)',
    icon: <InsuranceOutlined style={{ fontSize: 22 }} />,
    path: '/labor-ins',
  },
  {
    key: 'complaint-cause',
    title: '客訴原因設定',
    description: '客訴原因代號維護 (pwn101f1)',
    icon: <AlertOutlined style={{ fontSize: 22 }} />,
    path: '/complaint-cause',
  },
  {
    key: 'doc-setup',
    title: '文件設定',
    description: '文件編號與類別維護 (pwl102f1)',
    icon: <FolderOpenOutlined style={{ fontSize: 22 }} />,
    path: '/doc-setup',
  },
  {
    key: 'inv-process',
    title: '庫存處理方式維護',
    description: '庫存處理方式代號維護 (pwm105f1)',
    icon: <ToolOutlined style={{ fontSize: 22 }} />,
    path: '/inv-process',
  },
  {
    key: 'pension-params',
    title: '退休金參數建檔',
    description: '退休金提繳工資等級維護 (pw9138f1)',
    icon: <DollarOutlined style={{ fontSize: 22 }} />,
    path: '/pension-params',
  },
  {
    key: 'pack-customer',
    title: 'PACKING客戶資料建檔',
    description: 'PACKING客戶資料維護 (pwp151f1)',
    icon: <GiftOutlined style={{ fontSize: 22 }} />,
    path: '/pack-customer',
  },
  {
    key: 'pay-item',
    title: '薪資項目定義',
    description: '薪資項目代號與屬性維護 (pw9132f1)',
    icon: <AccountBookOutlined style={{ fontSize: 22 }} />,
    path: '/pay-item',
  },
  {
    key: 'leave-type',
    title: '假別設定',
    description: '假別參數維護 (pw9108f1)',
    icon: <CalendarOutlined style={{ fontSize: 22 }} />,
    path: '/leave-type',
  },
  {
    key: 'pw9213',
    title: '員工年度考勤記錄',
    description: '員工年度考勤記錄維護 (pw9213f1)',
    icon: <FieldTimeOutlined style={{ fontSize: 22 }} />,
    path: '/pw9213',
  },
  {
    key: 'pw9119',
    title: '感應卡保管建檔',
    description: '感應卡保管記錄維護 (pw9119f1)',
    icon: <CreditCardOutlined style={{ fontSize: 22 }} />,
    path: '/pw9119',
  },
  {
    key: 'pw9205',
    title: '職務代理人異動單',
    description: '職務代理人異動單建檔 (pw9205f1)',
    icon: <SwapOutlined style={{ fontSize: 22 }} />,
    path: '/pw9205',
  },
  {
    key: 'pw9201',
    title: '人員增補申請單',
    description: '人員增補申請單建檔 (pw9201f1)',
    icon: <TeamOutlined style={{ fontSize: 22 }} />,
    path: '/pw9201',
  },
  {
    key: 'p9207',
    title: '離職申請單',
    description: '離職申請單管理 (pw9207f1)',
    icon: <CloseCircleOutlined style={{ fontSize: 22, color: '#ff4d4f' }} />,
    path: '/p9207',
  },
  {
    key: 'p9209',
    title: '留職停薪申請單',
    description: '留職停薪申請單管理 (pw9209f1)',
    icon: <ClockCircleOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/p9209',
  },
  {
    key: 'pw9614',
    title: '請假月結作業',
    description: '請假月結作業 (pw9614f1)',
    icon: <CalendarOutlined style={{ fontSize: 22 }} />,
    path: '/pw9614',
  },
  {
    key: 'pw9531',
    title: '薪資計算',
    description: '薪資計算作業 (pw9531f1)',
    icon: <CalculatorOutlined style={{ fontSize: 22 }} />,
    path: '/pw9531',
  },
  {
    key: 'insp-method',
    title: '驗貨方式設定',
    description: '驗貨方式代號維護 (pw111gf1)',
    icon: <SafetyCertificateOutlined style={{ fontSize: 22 }} />,
    path: '/insp-method',
  },
  {
    key: 'test-item',
    title: '測試項目設定',
    description: '測試項目代號維護 (pw111af1)',
    icon: <FormOutlined style={{ fontSize: 22 }} />,
    path: '/test-item',
  },
  {
    key: 'work-schedule',
    title: '上班時間定義',
    description: '班別上下班時間維護 (pw910gf1)',
    icon: <ClockCircleOutlined style={{ fontSize: 22 }} />,
    path: '/work-schedule',
  },
  {
    key: 'vp-approval-priority',
    title: '副總核准權限順位',
    description: '副總核准權限順序設定 (pw910jf1)',
    icon: <FormOutlined style={{ fontSize: 22 }} />,
    path: '/vp-approval-priority',
  },
  {
    key: 'job-grade',
    title: '職等定義',
    description: '職等代號與名稱維護 (pw9103f1)',
    icon: <FormOutlined style={{ fontSize: 22 }} />,
    path: '/job-grade',
  },
  {
    key: 'dept-major',
    title: '科系定義檔',
    description: '科系名稱定義維護 (pw910qf1)',
    icon: <FormOutlined style={{ fontSize: 22 }} />,
    path: '/dept-major',
  },
  {
    key: 'material-report',
    title: '原料清冊',
    description: '原料主檔範圍查詢列印 (pw1311f1)',
    icon: <UnorderedListOutlined style={{ fontSize: 22 }} />,
    path: '/material-report',
  },
  {
    key: 'material',
    title: '原料建檔',
    description: '原料主檔建檔維護 (pw1111f1)',
    icon: <DatabaseOutlined style={{ fontSize: 22 }} />,
    path: '/material',
  },
  {
    key: 'payment-terms',
    title: '付款條件定義',
    description: '付款條件代號維護 (pw1116f1)',
    icon: <CreditCardOutlined style={{ fontSize: 22 }} />,
    path: '/payment-terms',
  },
  {
    key: 'warehouse-return-stats',
    title: '繳庫統計表',
    description: '繳庫統計查詢報表 (pwd318f1)',
    icon: <BarChartOutlined style={{ fontSize: 22 }} />,
    path: '/warehouse-return-stats',
  },
  {
    key: 'c5m5',
    title: '銷貨退回沖銷',
    description: '批量沖銷已核准的銷貨退回單',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/c5m5',
  },
  {
    key: 'c526',
    title: '銷貨退回單核准沖銷',
    description: '銷貨退回單核准沖銷 (pwc526f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/c526',
  },
  {
    key: 'c502',
    title: 'S/C 核准',
    description: '銷售合約批量核准 (pwc502f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/c502',
  },
  {
    key: 'c514',
    title: '異常交運單核准',
    description: '異常交運單批量核准 (pwc514f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/c514',
  },
  {
    key: 'c5n4',
    title: '異常交運單核准沖銷',
    description: '異常交運單核准沖銷 (pwc5n4f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/c5n4',
  },
  {
    key: 'g204',
    title: '銷貨折讓單',
    description: '銷貨折讓單建檔管理 (pwg204f1)',
    icon: <AccountBookOutlined style={{ fontSize: 22, color: '#faad14' }} />,
    path: '/g204',
  },
  {
    key: 't207',
    title: '廠商會議記錄',
    description: '廠商會議記錄管理 (pwt207f1)',
    icon: <TeamOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/t207',
  },
  {
    key: 'c209',
    title: '新布種開發申請單',
    description: '新布種開發申請單管理 (pwc209f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/c209',
  },
  {
    key: 'c212',
    title: '胚布預估單',
    description: '胚布預估單管理 (pwc212f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/c212',
  },
  {
    key: 'c205',
    title: '銷貨退回單建檔',
    description: '銷貨退回單建檔管理 (pwc205f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#f5222d' }} />,
    path: '/c205',
  },
  {
    key: 'c504',
    title: '交運單核准',
    description: '交運單批量核准 (pwc504f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/c504',
  },
  {
    key: 'd206',
    title: '繳庫退出單',
    description: '繳庫退出單建立 (pwd206f1)',
    icon: <SwapOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/d206',
  },
  {
    key: 'd506',
    title: '繳庫退出單核准',
    description: '繳庫退出單批量核准 (pwd506f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/d506',
  },
  {
    key: 'c5m4',
    title: '交運單沖銷',
    description: '交運單批量沖銷 (pwc5m4f1)',
    icon: <ScissorOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/c5m4',
  },
  {
    key: 'c5m2',
    title: 'S/C沖銷核准',
    description: '銷售合約批量沖銷 (pwc5m2f1)',
    icon: <ScissorOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/c5m2',
  },
  {
    key: 'c322',
    title: '訂單跟催表',
    description: '訂單跟催查詢報表 (pwc322f1)',
    icon: <OrderedListOutlined style={{ fontSize: 22 }} />,
    path: '/c322',
  },
  {
    key: 'd319',
    title: '託工入庫統計表',
    description: '託工入庫統計查詢報表 (pwd319f1)',
    icon: <BarChartOutlined style={{ fontSize: 22 }} />,
    path: '/d319',
  },
  {
    key: 'currency-report',
    title: '幣別清冊',
    description: '幣別代號範圍查詢清冊 (pw1308f1)',
    icon: <GlobalOutlined style={{ fontSize: 22 }} />,
    path: '/currency-report',
  },
  {
    key: 'j5n5',
    title: '研發託工單核准沖',
    description: '研發託工單批量沖銷 (pwj5n5f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/j5n5',
  },
  {
    key: 'j5n8',
    title: '新產品分析核准沖銷',
    description: '跨 J218/J219/J220/J228 選擇性核准沖銷 (pwj5n8f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#d4380d' }} />,
    path: '/j5n8',
  },
  {
    key: 'd202',
    title: '繳庫單',
    description: '採購繳庫作業 (pwd202f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/d202',
  },
  {
    key: 'd504',
    title: '託工入庫單核准',
    description: '託工入庫單批量核准 (pwd504f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/d504',
  },
  {
    key: 'd501',
    title: '採購單核准',
    description: '採購單批量核准 (pwd501f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#2f54eb' }} />,
    path: '/d501',
  },
  {
    key: 'p9513',
    title: '考勤核准(副總)',
    description: '請假/出差單副總核准 (pw9513f1)',
    icon: <SolutionOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/p9513',
  },
  {
    key: 'color-report',
    title: '色號清冊',
    description: '色號代號範圍查詢清冊 (pw1314f1)',
    icon: <BgColorsOutlined style={{ fontSize: 22 }} />,
    path: '/color-report',
  },
  {
    key: 'c330',
    title: '銷售退回明細表',
    description: '銷貨退回明細查詢報表 (pwc330f1)',
    icon: <RollbackOutlined style={{ fontSize: 22 }} />,
    path: '/c330',
  },
  {
    key: 'p15mh',
    title: '廠商評鑑核准',
    description: '廠商評鑑批量核准 (pw15mhf1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/p15mh',
  },
  {
    key: 'p15mj',
    title: '廠商評鑑研發核准',
    description: '廠商評鑑研發批量核准 (pw15mjf1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/p15mj',
  },
  {
    key: 'attendance-status',
    title: '出勤現況查詢',
    description: '當日員工出勤狀態查詢 (pw9410f1)',
    icon: <FieldTimeOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/attendance-status',
  },
  {
    key: 'd5m2',
    title: '繳庫單核准沖銷',
    description: '批量沖銷已核准的繳庫單 (pwd5m2f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/d5m2',
  },
  {
    key: 'd5n2',
    title: '異常繳庫單核准沖銷',
    description: '批量沖銷已核准的異常繳庫單 (pwd5n2f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#d4380d' }} />,
    path: '/d5n2',
  },
  {
    key: 'd514',
    title: '異常託工入庫單核准',
    description: '批量核准異常託工入庫單 (pwd514f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#d46b08' }} />,
    path: '/d514',
  },
  {
    key: 'd5n4',
    title: '異常託工入庫單核准沖銷',
    description: '批量沖銷已核准的異常託工入庫單 (pwd5n4f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#ad4e00' }} />,
    path: '/d5n4',
  },
  {
    key: 'd5m6',
    title: '繳庫退出單核准沖銷',
    description: '批量沖銷已核准的繳庫退出單 (pwd5m6f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#a8071a' }} />,
    path: '/d5m6',
  },
  {
    key: 'd5m1',
    title: '採購單核准沖銷',
    description: '批量沖銷已核准的採購單 (pwd5m1f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/d5m1',
  },
  {
    key: 'd5m4',
    title: '託工入庫單沖銷',
    description: '批量沖銷已核准的託工入庫單 (pwd5m4f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/d5m4',
  },
  {
    key: 'd5m3',
    title: '託工單核准沖銷',
    description: '批量沖銷已核准的託工單 (pwd5m3f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#531dab' }} />,
    path: '/d5m3',
  },
  {
    key: 'r5d6',
    title: '繳庫退出單沖銷',
    description: '批量沖銷已核准的繳庫退出單 (pwr5d6f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#cf1322' }} />,
    path: '/r5d6',
  },
  {
    key: 'c516',
    title: 'S/C 結案核准',
    description: '銷售合約批量結案 (pwc516f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/c516',
  },
  {
    key: 'c5n6',
    title: 'S/C 結案沖銷',
    description: '銷售合約結案沖銷 (pwc5n6f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#cf1322' }} />,
    path: '/c5n6',
  },
  {
    key: 'd502',
    title: '繳庫單核准',
    description: '繳庫單批量核准 (pwd502f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/d502',
  },
  {
    key: 'announcement',
    title: '公告建檔',
    description: '公告建檔維護 (pwt102f1)',
    icon: <NotificationOutlined style={{ fontSize: 22, color: '#faad14' }} />,
    path: '/announcement',
  },
  {
    key: 't202',
    title: '公告建檔申請書',
    description: '公告申請單建檔與核准 (pwt202f1)',
    icon: <FormOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/t202',
  },
  {
    key: 'n202',
    title: '客訴處理記錄單-採購',
    description: '客訴處理記錄與追蹤 (pwn202f1)',
    icon: <FileExclamationOutlined style={{ fontSize: 22, color: '#f5222d' }} />,
    path: '/n202',
  },
  {
    key: 'r5m3',
    title: '庫存交運清單核准沖銷',
    description: '批量沖銷已核准的庫存交運單 (pwr5m3f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#9254de' }} />,
    path: '/r5m3',
  },
  {
    key: 't5m2',
    title: '公告核准沖銷',
    description: '單位主管批量沖銷已核准公告 (pwt5m2f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/t5m2',
  },
  {
    key: 'm201',
    title: '產品異動調整單',
    description: '產品異動調整建檔維護 (pwm201f1)',
    icon: <SwapOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/m201',
  },
  {
    key: 'm501',
    title: '產品異動調整核准',
    description: '正常產品異動調整核准 (pwm501f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/m501',
  },
  {
    key: 'm207',
    title: '庫位板號修改單',
    description: '庫位板號修改建檔維護 (pwm207f1)',
    icon: <TagsOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/m207',
  },
  {
    key: 'm209',
    title: '研發架號修改單',
    description: '研發架號修改建檔維護 (pwm209f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/m209',
  },
  {
    key: 'announcement-query',
    title: '公告查詢',
    description: '公告日期範圍查詢 (pwt402f1)',
    icon: <SearchOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/announcement-query',
  },
  {
    key: 't206',
    title: '客戶會議記錄',
    description: '客戶會議記錄建檔維護 (pwt206f1)',
    icon: <SolutionOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/t206',
  },
  {
    key: 'r5d5',
    title: '領用單核准沖銷',
    description: '批量沖銷已核准的領用單 (pwr5d5f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/r5d5',
  },
  {
    key: 'r211',
    title: '入庫成本計算作業',
    description: '按月計算入庫成本 (pwr211f1)',
    icon: <CalculatorOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/r211',
  },
  {
    key: 'm302',
    title: '庫位庫存量表',
    description: '庫位庫存量查詢報表 (pwm302f1)',
    icon: <DatabaseOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/m302',
  },
  {
    key: 'm310',
    title: '庫位批號庫存表(量負)',
    description: '查詢庫存量為負的記錄 (pwm310f1)',
    icon: <WarningOutlined style={{ fontSize: 22, color: '#cf1322' }} />,
    path: '/m310',
  },
  {
    key: 'm303',
    title: '庫位批號庫存量表',
    description: '庫位批號庫存量查詢報表 (pwm303f1)',
    icon: <DatabaseOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/m303',
  },
  {
    key: 'n351',
    title: '客訴單追蹤查詢',
    description: '追蹤客訴單流程核准狀態 (pwn351f1)',
    icon: <FileExclamationOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/n351',
  },
  {
    key: 'r5m8',
    title: '客戶寄庫交運單沖銷',
    description: '批量沖銷已核准的寄庫交運單 (pwr5m8f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#389e0d' }} />,
    path: '/r5m8',
  },
  {
    key: 'n501',
    title: '客訴單核准',
    description: '業務組長核准客訴單 (pwn501f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/n501',
  },
  {
    key: 'n502',
    title: '客訴單主管初核',
    description: '主管多層核准客訴單 (pwn502f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/n502',
  },
  {
    key: 'n503',
    title: '客訴單品保核准',
    description: '品保部門核准客訴單 (pwn503f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/n503',
  },
  {
    key: 'm5m3',
    title: '庫存交運清單核准沖銷',
    description: '批量沖銷已核准的庫存交運清單 (pwm5m3f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#9254de' }} />,
    path: '/m5m3',
  },
  {
    key: 'm203',
    title: '庫存交運清單',
    description: '建立與維護庫存交運清單 (pwm203f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#1677ff' }} />,
    path: '/m203',
  },
  {
    key: 'm503',
    title: '庫存交運核准',
    description: '批次核准庫存交運清單 (pwm503f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/m503',
  },
  {
    key: 'inspection-request',
    title: '檢驗送件單',
    description: '檢驗送件單建檔維護 (pwp201f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/inspection-request',
  },
  {
    key: 'r5np',
    title: '客訴買收交運單核准',
    description: '批量沖銷已核准的客訴買收交運單 (pwr5npf1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/r5np',
  },
  {
    key: 'm5m1',
    title: '產品異動調整沖銷',
    description: '正常產品異動調整核准沖銷 (pwm5m1f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#faad14' }} />,
    path: '/m5m1',
  },
  {
    key: 'm5m8',
    title: '寄庫交運單沖銷',
    description: '客戶寄庫交運單沖銷 (pwm5m8f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/m5m8',
  },
  {
    key: 'n5p1',
    title: '客訴買收交運沖銷',
    description: '客訴工廠買收交運沖銷 (pwn5p1f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#f5222d' }} />,
    path: '/n5p1',
  },
  {
    key: 'r5d2',
    title: '繳庫單核准沖銷',
    description: '批量沖銷已核准的繳庫單 (pwr5d2f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/r5d2',
  },
  {
    key: 'p503',
    title: '物化性測試報告核准',
    description: '物化性測試報告批量核准 (pwp503f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/p503',
  },
  {
    key: 'p5m3',
    title: '物化性測試報告退核',
    description: '批次退回已核准的物化性測試報告 (pwp5m3f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#cf1322' }} />,
    path: '/p5m3',
  },
  {
    key: 'm301',
    title: '總庫存量表',
    description: '總庫存量查詢報表 (pwm301f1)',
    icon: <DatabaseOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/m301',
  },
  {
    key: 'm305',
    title: '訂單批號庫存表',
    description: '訂單批號庫存查詢報表 (pwm305f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/m305',
  },
  {
    key: 'n5m3',
    title: '客訴單品保沖銷',
    description: '客訴單品保核准沖銷 (pwn5m3f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#cf1322' }} />,
    path: '/n5m3',
  },
  {
    key: 'j501',
    title: '樣品申請單核准',
    description: '樣品申請單核准作業 (pwj501f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/j501',
  },
  {
    key: 'j514',
    title: '研發採購單核准',
    description: '研發採購單批量核准 (pwj514f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/j514',
  },
  {
    key: 'pw030a',
    title: '等級-人員清冊',
    description: '依等級代碼查詢人員清冊 (pw030af1)',
    icon: <TeamOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pw030a',
  },
  {
    key: 'pw0308',
    title: '系統使用記錄',
    description: '查詢使用者系統操作記錄 (pw0308f1)',
    icon: <FieldTimeOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw0308',
  },
  {
    key: 'p203',
    title: '物化性測試報告',
    description: '物化性測試報告建檔維護 (pwp203f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/p203',
  },
  {
    key: 'j5n4',
    title: '研發採購單沖銷',
    description: '研發採購單核准沖銷 (pwj5n4f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/j5n4',
  },
  {
    key: 'j5m3',
    title: '樣品交運單沖銷',
    description: '樣品交運單核准沖銷 (pwj5m3f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/j5m3',
  },
  {
    key: 'j5m8',
    title: '研發繳庫單沖銷',
    description: '研發繳庫單核准沖銷 (pwj5m8f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/j5m8',
  },
  {
    key: 'j5m1',
    title: '樣品申請單核准沖銷',
    description: '樣品申請單核准沖銷 (pwj5m1f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/j5m1',
  },
  {
    key: 'l303',
    title: '正式發行文件一覽',
    description: '正式發行文件清冊查詢 (pwl303f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/l303',
  },
  {
    key: 'l313',
    title: '正式發行文件列印',
    description: '正式發行文件頁次檢視 (pwl313f1)',
    icon: <FolderOpenOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/l313',
  },
  {
    key: 'j30c',
    title: '紙卡嘜頭列印',
    description: 'A4紙卡嘜頭列印 (pwj30cf1)',
    icon: <TagsOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/j30c',
  },
  {
    key: 'j515',
    title: '研發託工單核准',
    description: '研發託工單批量核准作業 (pwj515f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/j515',
  },
  {
    key: 'l402',
    title: '文件查詢',
    description: '依類別或關鍵字查詢文件及章節 (pwl402f1)',
    icon: <SearchOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/l402',
  },
  {
    key: 'l413',
    title: 'ISO正式發行文件查詢',
    description: '查詢ISO正式發行文件及章節內容 (pwl413f1)',
    icon: <SafetyCertificateOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/l413',
  },
  {
    key: 'l202',
    title: '章節內容維護',
    description: '文件章節建檔、查詢、管理 (pwl202f1)',
    icon: <OrderedListOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/l202',
  },
  {
    key: 'l204',
    title: 'ISO文件內頁建檔',
    description: 'ISO文件內頁建檔維護 (pwl204f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/l204',
  },
  {
    key: 'l205',
    title: 'ISO稽核查檢表',
    description: 'ISO內部品質稽核查檢表建檔 (pwl205f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/l205',
  },
  {
    key: 'l316',
    title: '稽核改善進度管制',
    description: '稽核改善進度管制報表 (pwl316f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/l316',
  },
  {
    key: 'j201',
    title: '樣品申請單',
    description: '樣品申請單建檔維護 (pwj201f1)',
    icon: <GiftOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/j201',
  },
  {
    key: 'j202',
    title: '樣品繳庫單',
    description: '樣品繳庫單建檔維護 (pwj202f1)',
    icon: <GiftOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/j202',
  },
  {
    key: 'j207',
    title: '研發領用單',
    description: '研發領用單建檔維護 (pwj207f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/j207',
  },
  {
    key: 'j502',
    title: '樣品繳庫單核准',
    description: '樣品繳庫單批量核准作業 (pwj502f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/j502',
  },
  {
    key: 'j208',
    title: '研發樣品繳庫單',
    description: '研發樣品繳庫建檔維護 (pwj208f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/j208',
  },
  {
    key: 'j212',
    title: '銷售專輯製作',
    description: '銷售專輯建檔維護、產品明細管理 (pwj212f1)',
    icon: <SkinOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/j212',
  },
  {
    key: 'j218',
    title: '新產品開發分析（單層梭織）',
    description: '新產品開發分析單建檔維護（單層梭織）(pwj218f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/j218',
  },
  {
    key: 'j219',
    title: '新產品開發分析',
    description: '新產品開發分析單建檔維護（洗標項目）(pwj219f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/j219',
  },
  {
    key: 'j214',
    title: '研發採購單',
    description: '研發採購單建檔、明細維護 (pwj214f1)',
    icon: <ShoppingOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/j214',
  },
  {
    key: 'j5m2',
    title: '樣品繳庫單核准沖銷',
    description: '樣品繳庫單核准沖銷 (pwj5m2f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#cf1322' }} />,
    path: '/j5m2',
  },
  {
    key: 'j203',
    title: '樣品交運單',
    description: '樣品交運單建檔維護 (pwj203f1)',
    icon: <GiftOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/j203',
  },
  {
    key: 'warehouse-location',
    title: '庫位建檔',
    description: '庫位主檔與控管人員維護 (pw1105f1)',
    icon: <BankOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/warehouse-location',
  },
  {
    key: 'color-code',
    title: '色號定義',
    description: '色號主檔建檔維護 (pw1114f1)',
    icon: <BgColorsOutlined style={{ fontSize: 22 }} />,
    path: '/color-code',
  },
  {
    key: 'business-card',
    title: '名片個人資料檔',
    description: '名片個人資料管理 (pw1103f1)',
    icon: <SolutionOutlined style={{ fontSize: 22 }} />,
    path: '/business-card',
  },
  {
    key: 'vendor-eval',
    title: '廠商評鑑單',
    description: '廠商評鑑建檔與信用管理 (pw110hf1)',
    icon: <AuditOutlined style={{ fontSize: 22 }} />,
    path: '/vendor-eval',
  },
  {
    key: 'employee',
    title: '員工資料',
    description: '員工基本資料建檔維護 (pw9101f1)',
    icon: <TeamOutlined style={{ fontSize: 22 }} />,
    path: '/employee',
  },
  {
    key: 'pwc201f1',
    title: '報價單管理',
    description: '報價單表頭與明細維護 (pwc201f1)',
    icon: <FileTextOutlined style={{ fontSize: 22 }} />,
    path: '/pwc201f1',
  },
  {
    key: 'pw9220',
    title: '簽到/退作業',
    description: '員工打卡簽到簽退作業 (pw9220f1)',
    icon: <FieldTimeOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/pw9220',
  },
  {
    key: 'pw9221f1',
    title: '請假單',
    description: '請假單建檔與核准管理 (pw9221f1)',
    icon: <CalendarOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pw9221f1',
  },
  {
    key: 'pw9224',
    title: '出差單（含國內外）',
    description: '出差單建檔與核准管理 (pw9224f1)',
    icon: <GlobalOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pw9224',
  },
  {
    key: 'pw9236f1',
    title: '獎金發放記錄',
    description: '獎金發放明細建檔與查詢 (pw9236f1)',
    icon: <GiftOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pw9236f1',
  },
  {
    key: 'pw9204f1',
    title: '人事異動單',
    description: '人事異動單建檔與核准管理 (pw9204f1)',
    icon: <SwapOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pw9204f1',
  },
  {
    key: 'complaint-req',
    title: '客訴處理要求設定',
    description: '客訴處理要求代號維護 (pwn103f1)',
    icon: <AlertOutlined style={{ fontSize: 22, color: '#f5222d' }} />,
    path: '/complaint-req',
  },
  {
    key: 'n211',
    title: '客訴工廠買收交運單',
    description: '客訴工廠買收交運單建檔管理 (pwn211f1)',
    icon: <SwapOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/n211',
  },
  {
    key: 'defect-cause',
    title: '瑕疵原因設定',
    description: '瑕疵因代號與名稱維護 (pwp111f1)',
    icon: <WarningOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/defect-cause',
  },
  {
    key: 'processing-fee',
    title: '工繳建檔',
    description: '工繳代號與名稱維護 (pw1112f1)',
    icon: <ToolOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/processing-fee',
  },
  {
    key: 'bonus-def',
    title: '獎金發放定義',
    description: '獎金發放項目定義維護 (pw9133f1)',
    icon: <GiftOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/bonus-def',
  },
  {
    key: 'proc-quality',
    title: '工繳品質要求設定',
    description: '工繳與品質要求對應維護 (pw111jf1)',
    icon: <SafetyCertificateOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/proc-quality',
  },
  {
    key: 'emp-shortcode',
    title: '員工簡碼設定',
    description: '員工簡碼與業別維護 (pw111kf1)',
    icon: <TeamOutlined style={{ fontSize: 22, color: '#2f54eb' }} />,
    path: '/emp-shortcode',
  },
  {
    key: 'dept-staffing',
    title: '部門編制設定',
    description: '部門職稱編制維護 (pw9106f1)',
    icon: <ApartmentOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/dept-staffing',
  },
  {
    key: 'proxy-setting',
    title: '代理人設定',
    description: '員工代理人設定維護 (pw9105f1)',
    icon: <SolutionOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/proxy-setting',
  },
  {
    key: 'job-title',
    title: '職稱定義',
    description: '職稱代號與名稱維護 (pw9102f1)',
    icon: <FormOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/job-title',
  },
  {
    key: 'holiday',
    title: '假日定義',
    description: '假日行事曆維護 (pw910hf1)',
    icon: <CalendarOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/holiday',
  },
  {
    key: 'receivable-detail',
    title: '應收帳款明細資料',
    description: '應收帳款明細建檔維護 (pwg103f1)',
    icon: <AccountBookOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/receivable-detail',
  },
  {
    key: 'g203',
    title: '應收帳款回覆作業',
    description: '應收帳款回覆查詢與批次更新 (pwg203f1)',
    icon: <AccountBookOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/g203',
  },
  {
    key: 'access-control',
    title: '使用權設定',
    description: '使用權限等級設定維護 (pw0107f1)',
    icon: <SafetyCertificateOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/access-control',
  },
  {
    key: 'accounting-voucher',
    title: '會計傳票鏈',
    description: 'CHAIN-29 暫存傳票確認與正式會計傳票維護',
    icon: <AccountBookOutlined style={{ fontSize: 22, color: '#2f54eb' }} />,
    path: '/accounting-voucher',
  },
  {
    key: 'consignment-ship',
    title: '客戶寄庫交運單',
    description: '客戶寄庫交運建檔維護 (pwm208f1)',
    icon: <SwapOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/consignment-ship',
  },
  {
    key: 'outbound-notice',
    title: '出庫通知單',
    description: '出庫通知建檔維護 (pwm206f1)',
    icon: <SwapOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/outbound-notice',
  },
  {
    key: 'new-product-report',
    title: '新產品開發分析表',
    description: '新產品開發分析報表 (pwj228f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/new-product-report',
  },
  {
    key: 'salary-adjust',
    title: '薪資調整',
    description: '員工薪資調整建檔 (pw9234f1)',
    icon: <WalletOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/salary-adjust',
  },
  {
    key: 'rd-subcontract',
    title: '研發託工單',
    description: '研發託工建檔維護 (pwj215f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/rd-subcontract',
  },
  {
    key: 'base-salary',
    title: '個人基本薪資設定',
    description: '個人基本薪資建檔 (pw9232f1)',
    icon: <WalletOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/base-salary',
  },
  {
    key: 'pw9233',
    title: '非固定薪資輸入',
    description: '非固定薪資輸入建檔 (pw9233f1)',
    icon: <WalletOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/pw9233',
  },
  {
    key: 'invoice-request',
    title: '開立發票申請單',
    description: '開立發票申請建檔 (pwg209f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/invoice-request',
  },
  {
    key: 'pw9210f1',
    title: '每日出勤記錄',
    description: '員工每日出勤刷卡記錄管理 (pw9210f1)',
    icon: <FieldTimeOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pw9210f1',
  },
  {
    key: 'pw2202f1',
    title: '採購退回單',
    description: '採購退回單管理 (pw2202f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pw2202',
  },
  {
    key: 'pw2204f1',
    title: '銷貨退回單',
    description: '銷貨退回單管理 (pw2204f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#f5222d' }} />,
    path: '/pw2204f1',
  },
  {
    key: 'shipping-order',
    title: '出貨單表單',
    description: '出貨單建檔維護 (pwc203f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/shipping-order',
  },
  {
    key: 'c204',
    title: '交運單建檔',
    description: '交運單建檔維護 (pwc204f1)',
    icon: <TransactionOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/c204',
  },
  {
    key: 'd201',
    title: '採購單建檔',
    description: '採購單建檔維護 (pwd201f1)',
    icon: <ShoppingOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/d201',
  },
  {
    key: 'd211',
    title: '計劃採購單',
    description: '計劃採購單建檔維護 (pwd211f1)',
    icon: <ShoppingOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/d211',
  },
  {
    key: 'd203',
    title: '受訂託工單',
    description: '受訂託工單建檔維護 (pwd203f1)',
    icon: <ShoppingOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/d203',
  },
  {
    key: 'pwd212',
    title: '計劃託工單',
    description: '計劃託工單建檔維護 (pwd212f1)',
    icon: <ShoppingOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/pwd212',
  },
  {
    key: 'd204',
    title: '託工入庫單',
    description: '託工入庫單建檔維護 (pwd204f1)',
    icon: <ShoppingOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/d204',
  },
  {
    key: 'pwd210',
    title: '驗布指示單',
    description: '驗布指示單（入庫單）(pwd210f1)',
    icon: <FileSearchOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pwd210',
  },
  {
    key: 'pwd216',
    title: '入庫單異常說明-採',
    description: '入庫單異常說明批次核准-採購 (pwd216f1)',
    icon: <FileExclamationOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/pwd216',
  },
  {
    key: 'pwd217',
    title: '入庫單異常說明-主管',
    description: '入庫單異常說明批次核准-主管 (pwd217f1)',
    icon: <SafetyCertificateOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/pwd217',
  },
  {
    key: 'pw2501',
    title: '採購入庫單-核准',
    description: '採購入庫單批量核准 (pw2501f1)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#2f54eb' }} />,
    path: '/pw2501',
  },
  {
    key: 'pw9403',
    title: '員工資料查詢-部門',
    description: '依部門查詢員工基本資料 (pw9403f1)',
    icon: <TeamOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pw9403',
  },
  {
    key: 'pw9404',
    title: '員工資料查詢-總經理',
    description: '供總經理查閱員工基本及薪資資料 (pw9404f1)',
    icon: <IdcardOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw9404',
  },
  {
    key: 'pw9411',
    title: '個人出勤狀況查詢',
    description: '個人出勤狀況查詢 (pw9411f1)',
    icon: <ScheduleOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pw9411',
  },
  {
    key: 'pw930b',
    title: '部門人事統計表',
    description: '部門人事統計報表 (pw930bf1)',
    icon: <SolutionOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/pw930b',
  },
  {
    key: 'pw9321',
    title: '請假明細表',
    description: '請假明細查詢報表 (pw9321f1)',
    icon: <ScheduleOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pw9321',
  },
  {
    key: 'pw9304',
    title: '人事通知單印表',
    description: '人事通知單列印 (pw9304f1)',
    icon: <IdcardOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/pw9304',
  },
  {
    key: 'p9306',
    title: '部門編制明細表',
    description: '部門編制明細查詢報表 (pw9306f1)',
    icon: <SolutionOutlined style={{ fontSize: 22, color: '#2f54eb' }} />,
    path: '/p9306',
  },
  {
    key: 'p9310',
    title: '個人日出勤明細表',
    description: '個人日出勤明細查詢報表 (pw9310f1)',
    icon: <ScheduleOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/p9310',
  },
  {
    key: 'pwg332',
    title: '交運單繳款明細表',
    description: '交運單繳款明細查詢報表 (pwg332f1)',
    icon: <AccountBookOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pwg332',
  },
  {
    key: 'pw150k',
    title: '廠商資格核准-總經理',
    description: '廠商資格總經理核准 (pw150kf1)',
    icon: <SafetyOutlined style={{ fontSize: 22, color: '#f5222d' }} />,
    path: '/pw150k',
  },
  {
    key: 'pw150h',
    title: '廠商資格核准-部門',
    description: '廠商資格部門核准 (pw150hf1)',
    icon: <SafetyOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pw150h',
  },
  {
    key: 'pw1315',
    title: '包裝方式清冊',
    description: '包裝方式查詢報表 (pw1315f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pw1315',
  },
  {
    key: 'pw1313',
    title: '產品清冊',
    description: '產品清冊查詢報表 (pw1313f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/pw1313',
  },
  {
    key: 'pw1312',
    title: '工繳清冊',
    description: '工繳代號查詢報表 (pw1312f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw1312',
  },
  {
    key: 'p131k',
    title: '員工簡碼清冊',
    description: '員工簡碼查詢清冊 (pw131kf1)',
    icon: <IdcardOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/p131k',
  },
  {
    key: 'pw98m2',
    title: '人事資料核准沖銷-門戶選單',
    description: '人事核准沖銷導航選單 (pw98m2f1)',
    icon: <ScheduleOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/pw98m2',
  },
  // --- Batch 31: Transaction Modules ---
  {
    key: 'pwh203', title: '薪資/費用沖帳單',
    description: '薪資費用沖帳管理 (pwh203f1)',
    icon: <WalletOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pwh203',
  },
  {
    key: 'pwh201', title: '請款單',
    description: '請款單建檔維護 (pwh201f1)',
    icon: <CreditCardOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/pwh201',
  },
  {
    key: 'pw2203', title: '銷貨出庫單',
    description: '銷貨出庫單管理 (pw2203f1)',
    icon: <ShoppingOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/pw2203',
  },
  {
    key: 'b255', title: '事務用品領用單',
    description: '事務用品領用管理 (pwb255f1)',
    icon: <GiftOutlined style={{ fontSize: 22, color: '#faad14' }} />,
    path: '/b255',
  },
  {
    key: 'c208', title: '客戶來樣分析',
    description: '客戶來樣分析管理 (pwc208f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/c208',
  },
  {
    key: 'd205', title: '領用單',
    description: '領用單管理 (pwd205f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#2f54eb' }} />,
    path: '/d205',
  },
  {
    key: 'pw9208', title: '資遣通知單',
    description: '資遣通知單管理 (pw9208f1)',
    icon: <AlertOutlined style={{ fontSize: 22, color: '#f5222d' }} />,
    path: '/pw9208',
  },
  {
    key: 'pwg201', title: '繳款單',
    description: '繳款單管理 (pwg201f1)',
    icon: <CreditCardOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/pwg201',
  },
  {
    key: 'pw220a', title: '盤存調整單',
    description: '盤存調整單管理 (pw220af1)',
    icon: <SwapOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw220a',
  },
  {
    key: 'pwp253', title: '送貨明細',
    description: 'PACKING送貨明細管理 (pwp253f1)',
    icon: <ShoppingOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pwp253',
  },
  {
    key: 'pwp252', title: 'PACKING-貨櫃',
    description: '貨櫃PACKING管理 (pwp252f1)',
    icon: <DatabaseOutlined style={{ fontSize: 22, color: '#531dab' }} />,
    path: '/pwp252',
  },
  {
    key: 'pwp255', title: 'PACKING客戶資料',
    description: 'PACKING LIST客戶資料（貨櫃）(pwp255f1)',
    icon: <DatabaseOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pwp255',
  },
  {
    key: 'pwj220', title: '新產品開發分析',
    description: '雙/多層織物開發分析 (pwj220f1)',
    icon: <ExperimentOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pwj220',
  },
  {
    key: 'pwh204', title: '進貨折讓單',
    description: '進貨折讓單管理 (pwh204f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#cf1322' }} />,
    path: '/pwh204',
  },
  {
    key: 'pwh205', title: '暫借款請款單',
    description: '暫借款請款單管理 (pwh205f1)',
    icon: <CreditCardOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pwh205',
  },
  {
    key: 'd214', title: '生產排程管理',
    description: '生產排程管理 (pwd214f1)',
    icon: <ScheduleOutlined style={{ fontSize: 22, color: '#389e0d' }} />,
    path: '/d214',
  },
  {
    key: 'pwm202', title: '庫位移轉單',
    description: '庫位移轉單管理 (pwm202f1)',
    icon: <SwapOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pwm202',
  },
  {
    key: 'pwg208', title: '開票申請單',
    description: '開票申請單管理 (pwg208f1)',
    icon: <AccountBookOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pwg208',
  },
  {
    key: 'pwt205', title: '會議記錄管理',
    description: '會議記錄管理 (pwt205f1)',
    icon: <FormOutlined style={{ fontSize: 22, color: '#597ef7' }} />,
    path: '/pwt205',
  },
  {
    key: 'pwm211', title: '庫位狀況回覆',
    description: '庫位狀況回覆作業 (pwm211f1)',
    icon: <DatabaseOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pwm211',
  },
  {
    key: 'pwp211', title: '外觀檢驗（驗布）',
    description: '外觀檢驗驗布管理 (pwp211f1)',
    icon: <SearchOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pwp211',
  },
  {
    key: 'pwn201', title: '客訴處理記錄',
    description: '客訴處理記錄管理 (pwn201f1)',
    icon: <AlertOutlined style={{ fontSize: 22, color: '#cf1322' }} />,
    path: '/pwn201',
  },
  // --- Batch 30: Report Query ---
  {
    key: 'pwg302', title: '應收帳款明細/統計',
    description: '應收帳款明細查詢報表 (pwg302f1)',
    icon: <AccountBookOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/pwg302',
  },
  {
    key: 'g303', title: '應收帳款月份統計',
    description: '應收帳款月份統計報表 (pwg303f1)',
    icon: <AccountBookOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/g303',
  },
  {
    key: 'pwg304', title: '預收帳款明細表',
    description: '預收帳款明細查詢報表 (pwg304f1)',
    icon: <AccountBookOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pwg304',
  },
  {
    key: 'pwj324', title: '專輯預估成本明細',
    description: '專輯預估成本查詢 (pwj324f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pwj324',
  },
  {
    key: 'pwj308', title: '研發廠商對帳單',
    description: '研發廠商對帳查詢 (pwj308f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pwj308',
  },
  {
    key: 'pw9312', title: '部門-日出勤異常表',
    description: '部門日出勤異常查詢 (pw9312f1)',
    icon: <ScheduleOutlined style={{ fontSize: 22, color: '#f5222d' }} />,
    path: '/pw9312',
  },
  {
    key: 'pw9314', title: '月份請假總表',
    description: '月份請假彙總報表 (pw9314f1)',
    icon: <ScheduleOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw9314',
  },
  {
    key: 'pw9318', title: '感應卡-每筆出勤明細',
    description: '感應卡出勤打卡明細查詢 (pw9318f1)',
    icon: <ScheduleOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pw9318',
  },
  {
    key: 'pw9319', title: '感應卡-保管清冊',
    description: '依員工代號範圍查詢感應卡保管清冊 (pw9319f1)',
    icon: <IdcardOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pw9319',
  },
  {
    key: 'pwc301', title: 'S/C明細表',
    description: '銷售合約明細查詢 (pwc301f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/pwc301',
  },
  {
    key: 'pw9322', title: '請假明細表（部門用）',
    description: '部門請假明細查詢 (pw9322f1)',
    icon: <ScheduleOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pw9322',
  },
  {
    key: 'pw9324',
    title: '年度請假總表',
    description: '員工年度請假彙總報表 (pw9324f1)',
    icon: <CalendarOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw9324',
  },
  {
    key: 'd301', title: '採購單明細表',
    description: '採購單明細表報表 (pwd301f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/d301',
  },
  {
    key: 'c358', title: 'S/C受訂統計排行表',
    description: 'S/C利潤分析報表 (pwc358fa)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/c358',
  },
  {
    key: 'd324', title: '領用單明細表',
    description: '領用單明細表報表 (pwd324f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/d324',
  },
  {
    key: 'c304', title: '交運明細表',
    description: '交運明細表報表 (pwc304f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/c304',
  },
  {
    key: 'p1304', title: '公司資料列印',
    description: '公司資料清冊/新舊代號對照表 (pw1304f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/p1304',
  },
  {
    key: 'g305', title: '繳款單明細表',
    description: '繳款單明細表報表 (pwg305f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/g305',
  },
  {
    key: 'h302', title: '應付帳款明細表',
    description: '應付帳款明細表報表 (pwh302f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/h302',
  },
  {
    key: 'c324', title: '交運對帳單',
    description: '交運對帳單報表 (pwc324f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/c324',
  },
  {
    key: 'd302', title: '繳庫單明細表',
    description: '繳庫單明細表報表 (pwd302f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/d302',
  },
  {
    key: 'd312', title: '繳庫進出明細表',
    description: '繳庫進出明細表報表 (pwd312f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/d312',
  },
  {
    key: 'd303', title: '託工單明細表-廠商',
    description: '託工單明細表報表 (pwd303f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/d303',
  },
  {
    key: 'd304', title: '託工入庫單明細表',
    description: '託工入庫單明細表報表 (pwd304f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/d304',
  },
  {
    key: 'd305', title: '採購單統計表',
    description: '採購單統計表報表 (pwd305f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/d305',
  },
  {
    key: 'c305', title: '交運統計表',
    description: '交運統計表報表 (pwc305f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/c305',
  },
  {
    key: 'pwc315', title: '交運單總表',
    description: '交運單總表報表 (pwc315f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pwc315',
  },
  {
    key: 'd306', title: '託工單統計表',
    description: '託工單統計表報表 (pwd306f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/d306',
  },
  {
    key: 'd309', title: '採購預計交期明細',
    description: '採購預計交期明細報表 (pwd309f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/d309',
  },
  {
    key: 'd313', title: '入布明細表',
    description: '入布明細表報表 (pwd313f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#2f54eb' }} />,
    path: '/d313',
  },
  {
    key: 'd314', title: '產品進貨成本表',
    description: '產品進貨成本報表 (pwd314f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/d314',
  },
  {
    key: 'd320', title: '廠商工繳比較表',
    description: '廠商工繳比較表報表 (pwd320f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/d320',
  },
  {
    key: 'd328', title: '異常入庫單說明明細表',
    description: '異常入庫單說明明細報表 (pwd328f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#597ef7' }} />,
    path: '/d328',
  },
  {
    key: 'pwd307', title: '廠商年度採購數量',
    description: '廠商年度採購數量報表 (pwd307f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pwd307',
  },
  {
    key: 'pwd308', title: '廠商年度託工數量',
    description: '廠商年度託工數量報表 (pwd308f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pwd308',
  },
  {
    key: 'pwj30a', title: '小嘜頭列印',
    description: '小嘜頭標籤列印 (pwj30af1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pwj30a',
  },
  {
    key: 'pwj30b', title: '標簽貼紙列印',
    description: '布樣標簽貼紙列印 (pwj30bf1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/pwj30b',
  },
  {
    key: 'pwl304', title: '發行文件一覽表',
    description: '發行文件查詢列印 (pwl304f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pwl304',
  },
  // --- Batch 30: Approval/Writeoff ---
  {
    key: 'pw98m5', title: '人事資料核准沖銷',
    description: '人事資料核准沖銷作業 (pw98m5f1)',
    icon: <ScheduleOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/pw98m5',
  },
  {
    key: 'pwc512', title: '計畫生產通知單核准',
    description: '計畫生產通知單核准 (pwc512f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/pwc512',
  },
  {
    key: 'pwd503', title: '計劃/受訂託工單核准',
    description: '託工單核准作業 (pwd503f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pwd503',
  },
  {
    key: 'pwr5c4', title: '交運單沖銷核准',
    description: '交運單沖銷核准 (pwr5c4f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#f5222d' }} />,
    path: '/pwr5c4',
  },
  {
    key: 'pwc505', title: '銷貨退回單核准',
    description: '銷貨退回單核准 (pwc505f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pwc505',
  },
  {
    key: 'pwh508', title: '請款單核准-主管',
    description: '請款單核准-主管 (pwh508f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pwh508',
  },
  {
    key: 'pwh5m8', title: '請款單核准沖銷',
    description: '請款單核准沖銷 (pwh5m8f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pwh5m8',
  },
  {
    key: 'pwg5m5', title: '應收帳款調整單沖銷',
    description: 'AR調整單沖銷 (pwg5m5f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pwg5m5',
  },
  {
    key: 'pwg5m4', title: '銷貨折讓單沖銷',
    description: '銷貨折讓單核准沖銷 (pwg5m4f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pwg5m4',
  },
  {
    key: 'pwg5m8', title: '開票申請單沖銷',
    description: '開票申請單核准沖銷 (pwg5m8f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pwg5m8',
  },
  {
    key: 'pwg5m1', title: '繳款單核准沖銷',
    description: '繳款單核准沖銷 (pwg5m1f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/pwg5m1',
  },
  {
    key: 'pwg504', title: '銷貨折讓單核准',
    description: '銷貨折讓單核准 (pwg504f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/pwg504',
  },
  {
    key: 'pwg501', title: '繳款單核准',
    description: '繳款單核准 (pwg501f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pwg501',
  },
  {
    key: 'pwd512', title: '異常繳庫單核准',
    description: '異常繳庫單核准 (pwd512f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#f5222d' }} />,
    path: '/pwd512',
  },
  {
    key: 'pwr5j3', title: '樣品交運單核准沖銷',
    description: '樣品交運單核准沖銷 (pwr5j3f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
    path: '/pwr5j3',
  },
  {
    key: 'pwj5m7', title: '研發領用單核准沖銷',
    description: '研發領用單核准沖銷 (pwj5m7f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pwj5m7',
  },
  {
    key: 'pwj508', title: '研發繳庫單核准',
    description: '研發繳庫單核准 (pwj508f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pwj508',
  },
  {
    key: 'pwj503', title: '樣品交運單核准',
    description: '樣品交運單核准 (pwj503f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/pwj503',
  },
  {
    key: 'pwn511', title: '客訴單-採購組長核准',
    description: '客訴單採購組長核准 (pwn511f1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pwn511',
  },
  {
    key: 'pwn5ma', title: '客訴單-業務經辦核准沖銷',
    description: '客訴單業務經辦核准沖銷 (pwn5maf1)',
    icon: <CheckCircleOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/pwn5ma',
  },
  {
    key: 'pwn5n1', title: '客訴單-採購組長核准沖銷',
    description: '客訴單採購組長核准沖銷 (pwn5n1f1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pwn5n1',
  },
  {
    key: 'pwn5mb', title: '客訴單-採購經辦核准沖銷',
    description: '客訴單採購經辦核准沖銷 (pwn5mbf1)',
    icon: <RollbackOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/pwn5mb',
  },
  {
    key: 'fin-billdata',
    title: '票據/支票管理',
    description: '票據支票建檔管理 (fin_billdata)',
    icon: <CreditCardOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/fin-billdata',
  },
  {
    key: 'pw933a',
    title: '部門薪資總表',
    description: '部門薪資彙總查詢報表 (pw933af1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pw933a',
  },
  {
    key: 'pw9334',
    title: '薪資異動記錄明細',
    description: '薪資異動記錄明細報表 (pw9334f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw9334',
  },
  {
    key: 'g306',
    title: '應收/付交運佣金餘額表',
    description: '應收/付交運佣金餘額表 (pwg306f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/g306',
  },
  {
    key: 'g319',
    title: '交運開票繳款明細',
    description: '交運開票繳款明細報表 (pwg319f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#52c41a' }} />,
    path: '/g319',
  },
  {
    key: 'h301',
    title: '應付未付款項明細',
    description: '應付未付款項明細報表 (pwh301f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/h301',
  },
  {
    key: 'h303',
    title: '應付帳款沖帳明細',
    description: '應付帳款沖帳明細報表 (pwh303f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/h303',
  },
  {
    key: 'h311',
    title: '請款明細表',
    description: '請款明細表報表 (pwh311f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/h311',
  },
  {
    key: 'h312',
    title: '暫不付款請款單明細',
    description: '暫不付款請款單明細報表 (pwh312f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/h312',
  },
  {
    key: 'pwj310',
    title: '原料代號與工廠布號對照表',
    description: '原料代號與工廠布號對照表 (pwj310f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/pwj310',
  },
  {
    key: 'pwp303',
    title: '物化性報告明細表',
    description: '物化性報告明細表 (pwp303f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pwp303',
  },
  {
    key: 'pw9335',
    title: '個人薪資單',
    description: '個人薪資單報表 (pw9335f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw9335',
  },
  {
    key: 'pw9336',
    title: '薪資印領清冊',
    description: '薪資印領清冊報表 (pw9336f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw9336',
  },
  {
    key: 'pw9337',
    title: '個人獎金明細表',
    description: '個人獎金明細報表 (pw9337f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw9337',
  },
  {
    key: 'pw9339',
    title: '薪資明細表',
    description: '薪資明細報表 (pw9339f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw9339',
  },
  {
    key: 'pw933b',
    title: '薪資撥款清冊',
    description: '薪資撥款清冊報表 (pw933bf1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw933b',
  },
  {
    key: 'pw9341',
    title: '個人年度薪資異動',
    description: '個人年度薪資異動報表 (pw9341f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pw9341',
  },
  {
    key: 'p9311',
    title: '刷卡每筆出勤明細表',
    description: '刷卡出勤明細查詢報表 (pw9311f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/p9311',
  },
  {
    key: 'p9315',
    title: '部門個人出勤時間',
    description: '部門個人月出勤時數統計 (pw9315f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/p9315',
  },
  {
    key: 'pwd310',
    title: '廠商對帳單',
    description: '廠商對帳單查詢報表 (pwd310f1)',
    icon: <AccountBookOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/pwd310',
  },
  {
    key: 'm309',
    title: '板號庫位批號庫存',
    description: '板號庫位批號庫存查詢報表 (pwm309f1)',
    icon: <BarChartOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/m309',
  },
  {
    key: 'n301',
    title: '客訴原因明細表',
    description: '客訴原因明細查詢報表 (pwn301f1)',
    icon: <AlertOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/n301',
  },
  {
    key: 'p9301',
    title: '員工資料表列印查詢',
    description: '依人員/部門範圍查詢員工資料並列印 (pw9301f1)',
    icon: <TeamOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
    path: '/p9301',
  },
  {
    key: 'p930h',
    title: '公司行事日曆',
    description: '公司行事日曆查詢維護 (pw930hf1)',
    icon: <CalendarOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
    path: '/p930h',
  },
  {
    key: 'pw9701',
    title: '人事各類單據',
    description: '人事各類單據導覽選單 (pw9701f1)',
    icon: <IdcardOutlined style={{ fontSize: 22, color: '#eb2f96' }} />,
    path: '/pw9701',
  },
  {
    key: 'c901g',
    title: '銷售稽核工具',
    description: '銷售稽核工具（大型批次稽核）(pwc901fg)',
    icon: <AuditOutlined style={{ fontSize: 22, color: '#fa541c' }} />,
    path: '/c901g',
  },
  {
    key: 'p251',
    title: '內外銷PACKING LIST',
    description: '內外銷PACKING LIST主表單 (pwp251f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pwp251',
  },
  {
    key: 'pwp254f1',
    title: '出貨包裝單',
    description: '內外銷-客 出貨包裝單 Packing List (pwp254f1)',
    icon: <FileTextOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
    path: '/pwp254',
  },
  {
    key: 'p2201',
    title: '採購入庫單',
    description: '採購入庫單建檔維護 (pw2201f1)',
    icon: <ShoppingOutlined style={{ fontSize: 22, color: '#1677ff' }} />,
    path: '/p2201',
  },
];
